import * as Yup from "yup";

const REQUIRED = "Please fill out this field.";
const GREATER_THAN_ZERO = "Enter a value greater than 0.";
export const MIN_LESS_THAN_MAX = "Min value must be less than Max.";
export const CEILING_ORDER = "Value at ≥ 27 °C must be less than value at ≥ 19 °C.";
const RANGE_0_100 = "Enter a value between 0 and 100.";

const emptyToUndefined = (value: number, original: unknown) =>
  original === "" ||
  original === null ||
  original === undefined ||
  (typeof original === "string" && !/\d/.test(original))
    ? undefined
    : value;

const positive = () => Yup.number().transform(emptyToUndefined).required(REQUIRED).moreThan(0, GREATER_THAN_ZERO);

const airQualityGas = Yup.object().shape({
  co2: positive(),
  hcho: positive(),
  tvoc: positive(),
});

const airQualityWithPm = Yup.object().shape({
  co2: positive(),
  hcho: positive(),
  tvoc: positive(),
  pm25: positive(),
  pm10: positive(),
});

const lessThan = (siblingKey: string, message: string) =>
  function (this: Yup.TestContext, value?: number) {
    const sibling = this.parent[siblingKey];
    if (value == null || sibling == null) {
      return true;
    }
    return value < sibling;
  };

const range0to100 = () =>
  Yup.number().transform(emptyToUndefined).required(REQUIRED).min(0, RANGE_0_100).max(100, RANGE_0_100);

export const validationSchema = Yup.object().shape({
  thresholdLimit: airQualityGas,
  shortTermLimit: airQualityWithPm,
  longTermLimit: airQualityWithPm,

  temperature: Yup.object().shape({
    min: Yup.number()
      .transform(emptyToUndefined)
      .required(REQUIRED)
      .test("min-less-than-max", MIN_LESS_THAN_MAX, lessThan("max", MIN_LESS_THAN_MAX)),
    max: Yup.number().transform(emptyToUndefined).required(REQUIRED),
  }),

  humidity: Yup.object().shape({
    recommendedMin: range0to100().test(
      "min-less-than-max",
      MIN_LESS_THAN_MAX,
      lessThan("recommendedMax", MIN_LESS_THAN_MAX),
    ),
    recommendedMax: range0to100(),
    neverExceedCeilingMin: range0to100().test(
      "ceiling-order",
      CEILING_ORDER,
      lessThan("neverExceedCeilingMax", CEILING_ORDER),
    ),
    neverExceedCeilingMax: range0to100(),
  }),
});
